import {computed} from "@preact/signals-core";
import {ReadonlySignal} from "@preact/signals-react";
import {s_char} from "./s_char";
import {modSum} from "./s_char_calc";
import {s_chars_mods} from "./s_chars_mods";
import {ICharArmor} from "../_interfaces/ICharArmor";
import {ICharMod} from "../_interfaces/ICharMod";
import {v4} from "uuid";
import {ModsAdd, ModsSourceDelete} from "../_api/BEMods";
import {s_app_cid, s_app_rid} from "./s_app";

export const s_char_mods_kv: ReadonlySignal<number> = computed(() => modSum(s_char.value.id, 'kv'));
export const s_char_mods_sv: ReadonlySignal<number> = computed(() => modSum(s_char.value.id, 'mv'));
export const s_char_mods_mv: ReadonlySignal<number> = computed(() => modSum(s_char.value.id, 'sv'));

export const s_char_mods_hit: ReadonlySignal<number> = computed(() => modSum(s_char.value.id, 'hit'));
export const s_char_mods_dmg: ReadonlySignal<number> = computed(() => modSum(s_char.value.id, 'dmg'));
export const s_char_mods_bew: ReadonlySignal<number> = computed(() => modSum(s_char.value.id, 'bew'));
export const s_char_mods_tot: ReadonlySignal<number> = computed(() => modSum(s_char.value.id, 'tot'));
export const s_char_mods_wund: ReadonlySignal<number> = computed(() => modSum(s_char.value.id, 'wund'));
export const s_char_mods_ep: ReadonlySignal<number> = computed(() => modSum(s_char.value.id, 'ep'));

export const s_char_mods_pr: ReadonlySignal<number> = computed(() => modSum(s_char.value.id, 'pr'));
export const s_char_mods_mr: ReadonlySignal<number> = computed(() => modSum(s_char.value.id, 'mr'));

export const s_char_mods_str: ReadonlySignal<number> = computed(() => modSum(s_char.value.id, 'str'));
export const s_char_mods_ges: ReadonlySignal<number> = computed(() => modSum(s_char.value.id, 'ges'));
export const s_char_mods_zae: ReadonlySignal<number> = computed(() => modSum(s_char.value.id, 'zae'));
export const s_char_mods_wil: ReadonlySignal<number> = computed(() => modSum(s_char.value.id, 'wil'));
export const s_char_mods_wah: ReadonlySignal<number> = computed(() => modSum(s_char.value.id, 'wah'));
export const s_char_mods_cha: ReadonlySignal<number> = computed(() => modSum(s_char.value.id, 'cha'));

export const s_char_mods_aggressiv: ReadonlySignal<boolean> = computed(() => {
    const charMods = s_chars_mods.value.get(s_char.value.id);
    if (charMods) return Array.from(charMods.values()).findIndex(m => m.msource === 'state_aggressiv') >= 0
    return false
});
export const s_char_mods_defensiv: ReadonlySignal<boolean> = computed(() => {
    const charMods = s_chars_mods.value.get(s_char.value.id);
    if (charMods) return Array.from(charMods.values()).findIndex(m => m.msource === 'state_defensiv') >= 0;
    return false
});
export const s_char_mods_bedraengt: ReadonlySignal<boolean> = computed(() => {
    const charMods = s_chars_mods.value.get(s_char.value.id);
    if (charMods) return Array.from(charMods.values()).findIndex(m => m.msource === 'state_bedraengt') >= 0
    return false
});
export const s_char_mods_niederschlag: ReadonlySignal<boolean> = computed(() => {
    const charMods = s_chars_mods.value.get(s_char.value.id);
    if (charMods) return Array.from(charMods.values()).findIndex(m => m.msource === 'state_niederschlag') >= 0
    return false
});

// wenn getragen, mods hinzufügen ggf mods entfernen
export const modArmor = (entry: ICharArmor) => {

    let modsAdd: ICharMod[] = [];

    if (entry.wear) {

        const charMods = s_chars_mods.value.get(s_char.value.id);

        if (charMods && Array.from(charMods.values()).filter(m => m.msourceid === entry.id).length < 1) {

            const pr_mod = entry.pr + entry.pr_mod;
            if (pr_mod > 0) {
                modsAdd.push({
                    id: v4(),
                    cid: s_app_cid.value,
                    mfrom: entry.name,
                    what: 'pr',
                    mmod: pr_mod,
                    type: 'constant',
                    disabled: true,
                    duration: 0,
                    strain: 0,
                    sl: false,
                    msource: 'armor',
                    msourceid: entry.id
                });
            }

            const mr_mod = entry.mr + entry.mr_mod;
            if (mr_mod > 0) {
                modsAdd.push({
                    id: v4(),
                    cid: s_app_cid.value,
                    mfrom: entry.name,
                    what: 'mr',
                    mmod: mr_mod,
                    type: 'constant',
                    disabled: true,
                    duration: 0,
                    strain: 0,
                    sl: false,
                    msource: 'armor',
                    msourceid: entry.id
                });
            }

            const ini_mod = entry.ini + entry.ini_mod;
            if (ini_mod > 0) {
                modsAdd.push({
                    id: v4(),
                    cid: s_app_cid.value,
                    mfrom: entry.name,
                    what: 'ini',
                    mmod: ini_mod,
                    type: 'constant',
                    disabled: true,
                    duration: 0,
                    strain: 0,
                    sl: false,
                    msource: 'armor',
                    msourceid: entry.id
                });
            }
        }
    } else {
        ModsSourceDelete(s_char.value.id, s_app_rid.value, 'armor', entry.id)
    }

    if (modsAdd.length > 0) ModsAdd(s_char.value.id, s_app_rid.value, modsAdd)
}
